// Arabic strings for the redesigned Products analytics workspace
// (components/Reports/ProductsWorkspace).
const trans = {
  // Tabs + page chrome
  Pulse: "النبض",
  Performance: "الأداء",
  "Product Movement": "حركة المنتجات",
  "Product Affinity": "ترابط المنتجات",
  "Catalog Export": "تصدير الكتالوج",
  "Product analytics across performance, catalog movement and affinity.":
    "تحليلات المنتجات عبر الأداء وحركة الكتالوج والترابط.",

  // Pulse KPIs + hints
  "Product revenue": "إيرادات المنتجات",
  "Revenue from products sold in the period": "الإيرادات من المنتجات المباعة خلال الفترة",
  "Revenue from products sold in the period, including options and extra fields": "الإيرادات من المنتجات المباعة خلال الفترة، شاملة الخيارات والحقول الإضافية",
  "Units sold": "الوحدات المباعة",
  "Total item quantity sold across orders": "إجمالي كمية العناصر المباعة عبر الطلبات",
  "Products sold": "المنتجات المباعة",
  "Distinct products that sold at least once": "المنتجات المختلفة التي بيعت مرة واحدة على الأقل",
  "Items / order": "العناصر / الطلب",
  "Average items per order": "متوسط العناصر لكل طلب",
  "Avg item price": "متوسط سعر العنصر",
  "Average revenue per unit sold": "متوسط الإيراد لكل وحدة مباعة",
  "Best-selling product": "المنتج الأكثر مبيعًا",

  // Revenue concentration (Pareto)
  "Revenue concentration": "تركّز الإيرادات",
  "Top 10 products": "أفضل ١٠ منتجات",
  "of revenue": "من الإيرادات",
  Just: "فقط",
  "products drive half of all revenue": "منتجات تحقق نصف إجمالي الإيرادات",
  sold: "مُباع",

  // Menu engineering quadrant
  "Menu engineering": "هندسة القائمة",
  "Each bubble is a product · right = sells more · up = higher value per unit · size = revenue":
    "كل فقاعة تمثّل منتجًا · يمين = مبيعات أكثر · أعلى = قيمة أعلى للوحدة · الحجم = الإيرادات",
  "Units sold (popularity)": "الوحدات المباعة (الشعبية)",
  "Revenue / unit (value)": "الإيراد / الوحدة (القيمة)",
  "Revenue / unit": "الإيراد / الوحدة",
  Stars: "النجوم",
  Plowhorses: "الأحصنة العاملة",
  Puzzles: "الألغاز",
  Dogs: "الكلاب",
  "Popular & high value — feature them": "رائجة وعالية القيمة — أبرِزها",
  "High volume, low value — bundle or nudge price": "مبيعات عالية وقيمة منخفضة — اجمعها أو ارفع السعر",
  "High value, low volume — promote / reposition": "قيمة عالية ومبيعات منخفضة — روّج لها / أعد تموضعها",
  "Low volume & value — review or drop": "مبيعات وقيمة منخفضة — راجعها أو احذفها",
  unit: "وحدة",
  units: "وحدة",

  // Category mix
  "Category mix": "توزيع الفئات",
  "Revenue share by category": "حصة الإيرادات حسب الفئة",
  Uncategorized: "غير مصنّف",

  // Inventory
  "Inventory alerts": "تنبيهات المخزون",
  "Restock soon": "أعد التخزين قريبًا",
  "days left": "يوم متبقٍ",
  day: "يوم",
  "Dead stock": "مخزون راكد",
  "tied up": "مجمّدة",
  "on hand, 0 sold": "متوفر، 0 مبيعات",
  "No stock signals": "لا توجد إشارات مخزون",
  "Inventory on hand": "المخزون المتوفر",
  "Days of cover": "أيام التغطية",

  // Combos / affinity
  "Combo & upsell ideas": "أفكار العروض والبيع الإضافي",
  "Frequently bought together": "يُشترى معًا بكثرة",
  "Top combos": "أفضل العروض",
  "Most frequent pairings": "أكثر الاقترانات تكرارًا",
  attach: "ارتباط",
  together: "معًا",
  "Product A": "المنتج أ",
  "Product B": "المنتج ب",
  "Times bought together": "مرات الشراء معًا",
  "Confidence %": "نسبة الثقة",
  "Revenue impact": "أثر الإيرادات",
  "Products frequently bought together for combos, upsell and cross-sell.":
    "منتجات تُشترى معًا بكثرة لإنشاء العروض والبيع الإضافي والتكميلي.",

  // Performance
  "Top products by revenue": "أفضل المنتجات حسب الإيرادات",
  "Product Performance": "أداء المنتجات",
  "Exact revenue and units for every product sold in the period.":
    "الإيرادات والوحدات الدقيقة لكل منتج بيع خلال الفترة.",
  "Last sold date": "تاريخ آخر بيع",

  // Movement
  "Compare unsold, top-selling and least-selling products.":
    "قارن المنتجات غير المباعة والأكثر والأقل مبيعًا.",
  "Never Sold": "لم تُبع أبدًا",
  "Most Selling": "الأكثر مبيعًا",
  "Least Selling": "الأقل مبيعًا",
  "Most selling": "الأكثر مبيعًا",
  "Least selling": "الأقل مبيعًا",
  SKU: "وحدة حفظ المخزون",
  "Group by SKU": "تجميع حسب وحدة حفظ المخزون",
  "Created date": "تاريخ الإنشاء",
  "Days since last sale": "الأيام منذ آخر بيع",
  "Shown when a branch tracks stock": "يظهر عندما يتتبع الفرع المخزون",

  // Catalog
  "Export the full product catalog including composites and inventory structure.":
    "صدّر كتالوج المنتجات الكامل بما في ذلك المنتجات المركّبة وبنية المخزون.",
  "What's included": "ما المتضمَّن",
  "Export catalog (Excel)": "تصدير الكتالوج (إكسل)",
  "Export CSV": "تصدير CSV",
  "Simple products": "منتجات بسيطة",
  "Catalog rows": "صفوف الكتالوج",
  Choices: "الخيارات",
  "Composite products": "منتجات مركّبة",
  Recipes: "الوصفات",
  "Composite inventory": "مخزون المنتجات المركّبة",
  "BOM links": "روابط قائمة المكوّنات",
  "Ingredients / components": "المكوّنات / الأجزاء",

  // Misc
  "Drill-down": "تفاصيل",
  "Preparing export...": "جارٍ تجهيز التصدير...",
};

export default trans;
